import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface FeedbackOptions {
    message: string;
    duration?: number;
}

@Injectable({ providedIn: 'root' })
export class ConfirmationFeedbackService {
    private feedbackState$ = new BehaviorSubject<FeedbackOptions | null>(null);
    private timeoutId: any = null;

    get feedbackState() {
        return this.feedbackState$.asObservable();
    }

    show(message: string, callback?: () => void, duration: number = 3000): Promise<void> {
        this.feedbackState$.next({ message, duration });

        return new Promise<void>(resolve => {
            this.timeoutId = setTimeout(() => {
                this.hide();
                if (callback) callback();
                resolve();
            }, duration);
        });
    }

    hide() {
        this.feedbackState$.next(null);
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
}
